import { render, staticRenderFns } from "@/modules/Ticket/templates/tickets-list.html?vue&type=template&id=e09e3cda&scoped=true&"
import script from "@/modules/Ticket/scripts/tickets-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Ticket/scripts/tickets-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Ticket/styles/tickets-list.scss?vue&type=style&index=0&id=e09e3cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e09e3cda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
